import { Icon, IconsEnum } from 'components/Icons';

import { Button } from 'components/button';
import { Dialog } from 'components/dialog';
import { DialogProps } from '@radix-ui/react-dialog';
import { MovimentiResponseApiItem } from 'lib/api/movimentiResponseApi';
import styles from './CancelWithdrawalModal.module.scss';
import useWindowSize from 'hooks/useWindowSize';

export type CancelWithdrawalModalProps = DialogProps & {
  title: string;
  item?: MovimentiResponseApiItem;
  subtitle?: string;
  labelAnnulla: string;
  labelConferma: string;
  closeModal?: () => void;
  abortWithdrawal: (item: MovimentiResponseApiItem) => void;
};

export const CancelWithdrawalModal = ({
  title,
  subtitle,
  item,
  labelAnnulla,
  labelConferma,
  closeModal,
  abortWithdrawal,
  ...props
}: CancelWithdrawalModalProps) => {
  const { isMobile } = useWindowSize();

  return (
    <Dialog {...props} open={props.open} onOpenChange={props.onOpenChange}>
      <div className={styles.container}>
        <Icon iconId={IconsEnum.ROUND_QUESTION} className={`${styles.icon}`} color="var(--color-accent)" />
        <p className={`${styles.title} ${styles.uppercase}`}>{title}</p>
        {subtitle && <p className={styles.text}>{subtitle}</p>}
      </div>
      <div className={styles.buttonsContainer}>
        <Button
          size={isMobile ? 'medium' : undefined}
          visualizationType="tertiary"
          onClick={() => closeModal && closeModal()}
        >
          {labelAnnulla}
        </Button>
        <Button
          size={isMobile ? 'medium' : undefined}
          visualizationType="secondary"
          onClick={() => {
            item && abortWithdrawal(item);
            closeModal && closeModal();
          }}
        >
          {labelConferma}
        </Button>
      </div>
    </Dialog>
  );
};
